import { ClassAttributes, HTMLAttributes } from "react";
import { Theme, css } from "@emotion/react";
import styled, { Interpolation } from "@emotion/styled";
import localFont from "@next/font/local";

const SpoqaHanSansNeo = localFont({
  src: [
    {
      path: "../../../public/fonts/SpoqaHanSansNeo-Bold.ttf",
      weight: "700",
      style: "normal",
    },
  ],
  display: "swap",
});

const Badge = styled.div`
  width: 44px;
  height: 44px;
  background-color: ${({ theme }) => theme.color.grey_12};
  font-weight: 700;
  font-size: 18px;
  line-height: 1.4;
  color: ${({ theme }) => theme.color.grey_f};

  @media (max-width: 768px) {
    width: 147px;
    height: 34px;
    padding: 7px 0 5px;
    font-size: 14px;
  }
`;

export const RecommendOrderBadge = ({
  children,
  ...props
}: ClassAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    css?: Interpolation<Theme>;
  }) => {
  return (
    <Badge {...props}>
      <div
        className={SpoqaHanSansNeo.className}
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        `}
      >
        {children}
      </div>
    </Badge>
  );
};
